import { getStateWithOnlyOneLevel } from '../../utilities/StateSelectorHelper';

function getState(state) {
  return getStateWithOnlyOneLevel(state, 'settings');
}

export const getSettings = (state) => getState(state).get('settings');
export const getLoading = (state) => getState(state).get('loading');
export const getCommonAiAdminFeedbackTemplates = (state) =>
  getState(state).get('commonAiAdminFeedbackTemplates');
